import './styles/index.scss';

import { Grid } from '@mui/material';

import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { useAccessPermissionsMutation } from 'api/hooks/accessHandler';
import MultistepForm from 'app/components/MultistepForm';
import { actions as AlertActions } from 'app/containers/Dashboard/Alert/slice';
import { translations } from 'locales/i18n';

import { PermissionGeneral } from './components/PermissionGeneral';

interface Props {
  onCancel: Function;
  closeHandler: Function;
  setDisabledCancel?: Function;
  permission?: { id: number; permission: String } | null;
}

export function PermissionModal(props: Props) {
  const { create, update } = useAccessPermissionsMutation();

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const initialValues = () => {
    return props.permission
      ? {
          id: props.permission.id,
          service: props.permission.permission.split('_')[0],
          function: props.permission.permission.split('_')[1],
          scope: props.permission.permission.split('_')[2]
        }
      : { service: '', function: '', scope: null };
  };

  const handleSaveClick = async values => {
    if (create.isPending || update.isPending) {
      return;
    }
    if (props.setDisabledCancel) {
      props.setDisabledCancel(true);
    }
    const permissionString = `${values.service.toUpperCase()}_${values.function.toUpperCase()}_${
      values.scope
    }`;

    if (values.id) {
      try {
        await update.mutateAsync({
          id: values.id,
          data: { name: permissionString }
        });
        dispatch(AlertActions.success(t(translations.pages.permissions.alerts.saveSuccess())));
      } catch (err) {
        dispatch(AlertActions.error(t(translations.pages.permissions.alerts.saveFailed())));
      }
    } else {
      try {
        await create.mutateAsync({ name: permissionString });
        dispatch(AlertActions.success(t(translations.pages.permissions.alerts.saveSuccess())));
      } catch (err) {
        dispatch(AlertActions.error(t(translations.pages.permissions.alerts.saveFailed())));
      }
    }
    props.closeHandler();
    if (props.setDisabledCancel) {
      props.setDisabledCancel(false);
    }
  };

  const steps = ['Role Creation'];

  const PermissionModalStep = ({ step }) => {
    switch (step) {
      case 0:
        return <PermissionGeneral />;
      default:
        return null;
    }
  };

  return (
    <Grid item className="role-modal">
      <Formik
        initialValues={initialValues()}
        onSubmit={values => {
          handleSaveClick(values);
        }}
      >
        <MultistepForm
          submitting={create.isPending || update.isPending}
          steps={steps}
          onCancel={props.onCancel}
          hideStepper
        >
          {activeStep => <PermissionModalStep step={activeStep} />}
        </MultistepForm>
      </Formik>
    </Grid>
  );
}
